module.exports = __webpack_public_path__ + "img/icono-camara-gris.818fc75b.png";